var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMuteSound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4314 1.22008C10.4314 0.733185 10.0743 0.333496 9.57428 0.333496C9.22427 0.333496 8.98855 0.486104 8.60997 0.849458L5.67419 3.66908C5.63134 3.71268 5.58848 3.74175 5.53848 3.75628L5.24561 3.77082L10.4314 9.04671V1.22008ZM12.7243 14.17C12.9458 14.388 13.2958 14.388 13.5029 14.17C13.7172 13.9447 13.7244 13.5959 13.5029 13.3779L1.2741 0.936662C1.05981 0.718651 0.702659 0.718651 0.488368 0.936662C0.281221 1.14741 0.281221 1.51803 0.488368 1.72877L12.7243 14.17ZM3.13843 10.0641H5.26704C5.33847 10.0641 5.40276 10.0859 5.44562 10.1295L8.60997 13.1889C8.95284 13.516 9.23856 13.6613 9.58856 13.6613C9.91714 13.6613 10.1814 13.4869 10.31 13.2325C10.3386 13.1671 10.3672 13.0945 10.3886 13.0145L1.94554 4.42485C1.70982 4.68647 1.58839 5.08616 1.58839 5.60212V8.41447C1.58839 9.50453 2.13126 10.0641 3.13843 10.0641Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMuteSound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mute-sound.5a2432f42341502ee1daeb4e218e4f04.svg";